export const emptyTableDataStyle = {
	title: {
		textAlign: 'center',
		padding: '40px 0',
		fontSize: '18px',
	},
};
